"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureStyle = featureStyle;
exports.editHandleStyle = editHandleStyle;

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RECT_STYLE = {
  stroke: '#7ac943',
  strokeWidth: 2,
  x: -6,
  y: -6,
  height: 12,
  width: 12
};
var CIRCLE_RADIUS = 8;
var SELECTED_STYLE = {
  stroke: '#7ac943',
  strokeWidth: 2,
  fill: '#ffff00',
  fillOpacity: 0.7
};
var HOVERED_STYLE = {
  stroke: '#7ac943',
  strokeWidth: 2,
  fill: '#7ac943',
  fillOpacity: 0.5
};
var UNCOMMITTED_STYLE = {
  stroke: '#a7a7a7',
  strokeWidth: 2,
  fill: '#a9a9a9',
  fillOpacity: 0.3
};
var INACTIVE_STYLE = UNCOMMITTED_STYLE;
var DEFAULT_STYLE = {
  stroke: '#000000',
  strokeWidth: 2,
  fill: '#a9a9a9',
  fillOpacity: 0.1
};

function featureStyle(_ref) {
  var feature = _ref.feature,
      state = _ref.state;
  var type = feature.properties.shape || feature.geometry.type;
  var style = null;

  switch (state) {
    case _constants.RENDER_STATE.SELECTED:
      style = _objectSpread({}, SELECTED_STYLE);
      break;

    case _constants.RENDER_STATE.HOVERED:
      style = _objectSpread({}, HOVERED_STYLE);
      break;

    case _constants.RENDER_STATE.UNCOMMITTED:
    case _constants.RENDER_STATE.CLOSING:
      style = _objectSpread({}, UNCOMMITTED_STYLE);
      break;

    case _constants.RENDER_STATE.INACTIVE:
      style = _objectSpread({}, INACTIVE_STYLE);
      break;

    default:
      style = _objectSpread({}, DEFAULT_STYLE);
  }

  switch (type) {
    case _constants.SHAPE.POINT:
      style.r = CIRCLE_RADIUS;
      break;

    case _constants.SHAPE.LINE_STRING:
      style.fill = 'none';
      break;

    case _constants.SHAPE.POLYGON:
      if (state === _constants.RENDER_STATE.CLOSING) {
        style.strokeDasharray = '4,2';
      }

      break;

    case _constants.SHAPE.RECTANGLE:
      if (state === _constants.RENDER_STATE.UNCOMMITTED) {
        style.strokeDasharray = '4,2';
      }

      break;

    default:
  }

  return style;
}

function editHandleStyle(_ref2) {
  var feature = _ref2.feature,
      shape = _ref2.shape,
      index = _ref2.index,
      state = _ref2.state;
  var style = {};

  switch (state) {
    case _constants.RENDER_STATE.SELECTED:
      style = _objectSpread({}, SELECTED_STYLE);
      break;

    case _constants.RENDER_STATE.HOVERED:
      style = _objectSpread({}, HOVERED_STYLE);
      break;

    case _constants.RENDER_STATE.UNCOMMITTED:
    case _constants.RENDER_STATE.CLOSING:
      style = _objectSpread({}, UNCOMMITTED_STYLE);
      break;

    case _constants.RENDER_STATE.INACTIVE:
      style = _objectSpread({}, INACTIVE_STYLE);
      break;

    default:
      style = _objectSpread({}, DEFAULT_STYLE);
  }

  switch (shape) {
    case 'circle':
      //@ts-ignore
      style.r = CIRCLE_RADIUS;
      break;

    case 'rect':
      style = _objectSpread({}, style, {}, RECT_STYLE);
      break;

    default:
  }

  return style;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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